import React, { Component } from "react";

import {
  CModal,
  CModalHeader,
  CModalTitle,
  CModalBody,
  CModalFooter,
  CButton,
  CCard,
  CCardHeader,
  CCardBody,
  CSpinner
} from "@coreui/react";
import { toastr } from "react-redux-toastr";
import {
  FormGroup,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Label
} from "reactstrap";

import URL from "../../../config/api";
import axios from "../../../config/axios";
import SelectFilter from "../../SelectFilter";
import "./styles.css";

class QuestionModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      useAbility: true,
      itemDescription: "",
      curriculumComponent: "",
      segment: "",
      module: "",
      ability: "",
      selectedItem: null,
      loadingAbilities: false,
      availableItems: [],
      loadingAvailableItems: false,
      isOpenQuestion: false,
      newOptionText: "",
      selectedOptions: [],
      availableOptions: [],
      loadingAvailableOptions: false,
      creating: false,
      curriculumComponents: [],
      segments: [],
      modules: [],
      abilities: [],
      // NOVO: campo de cor
      itemColor: "" // Cor do item (formato hexadecimal)
    };
  }

  async componentDidMount() {
    if (this.state.useAbility) {
      this.loadAbilitiesData();
    }
    await this.fetchAvailableItemsOptions();
  }

  fetchAvailableItemsOptions = async () => {
    if (!this.props.user?.token) return;

    this.setState({
      loadingAvailableItems: true,
      loadingAvailableOptions: true
    });
    try {
      const [itemsResp, optionsResp] = await Promise.all([
        axios.get(`${URL.api}pedagogical/follow-ups/items/list`, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        }),
        axios.get(`${URL.api}pedagogical/follow-ups/options/list`, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        })
      ]);
      if (itemsResp.data?.success) {
        this.setState({ availableItems: itemsResp.data.data || [] });
      } else {
        this.setState({ availableItems: [] });
      }
      if (optionsResp.data?.success) {
        this.setState({ availableOptions: optionsResp.data.data || [] });
      } else {
        this.setState({ availableOptions: [] });
      }
    } catch (err) {
      console.error("Erro ao buscar itens/opções:", err);
      this.setState({ availableItems: [], availableOptions: [] });
    } finally {
      this.setState({
        loadingAvailableItems: false,
        loadingAvailableOptions: false
      });
    }
  };

  resetModalState = () => {
    this.setState({
      useAbility: true,
      itemDescription: "",
      curriculumComponent: "",
      segment: "",
      module: "",
      ability: "",
      selectedItem: null,
      loadingAbilities: false,
      availableItems: [],
      loadingAvailableItems: false,
      isOpenQuestion: false,
      newOptionText: "",
      selectedOptions: [],
      availableOptions: [],
      loadingAvailableOptions: false,
      creating: false,
      curriculumComponents: [],
      segments: [],
      modules: [],
      abilities: [],
      itemColor: "" // Resetar cor
    });
  };

  handleColorChange = e => {
    let value = e.target.value;
    // Validar formato básico de hex
    if (value === "" || /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/.test(value)) {
      this.setState({ itemColor: value });
      // Se já existe um item selecionado, atualiza a cor dele também
      if (this.state.selectedItem) {
        this.setState(prevState => ({
          selectedItem: {
            ...prevState.selectedItem,
            color: value || null
          }
        }));
      }
    }
  };

  handleAbilityToggle = () => {
    this.setState(
      prevState => ({
        useAbility: !prevState.useAbility,
        curriculumComponent: "",
        segment: "",
        module: "",
        ability: "",
        itemDescription: "",
        selectedItem: !prevState.useAbility ? prevState.selectedItem : null,
        itemColor: "" // Resetar cor ao trocar modo
      }),
      () => {
        if (this.state.useAbility) {
          this.loadAbilitiesData();
        }
      }
    );
  };

  loadAbilitiesData = () => {
    if (!this.props.user?.token) return;

    this.setState({ loadingAbilities: true });
    Promise.all([
      axios.get(`${URL.api}classification/discipline/list`, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      }),
      axios.get(`${URL.api}classification/segment/list`, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
    ])
      .then(([disciplineResp, segmentResp]) => {
        console.log("Dados iniciais carregados:", {
          disciplines: disciplineResp.data,
          segments: segmentResp.data
        });

        const newState = { loadingAbilities: false };

        if (disciplineResp.data.success) {
          newState.curriculumComponents = disciplineResp.data.data;
        }

        if (segmentResp.data.success) {
          newState.segments = segmentResp.data.data;
        }

        this.setState(newState);
      })
      .catch(error => {
        console.error("Erro ao carregar dados iniciais:", error);
        this.setState({ loadingAbilities: false });
        toastr.error(
          "Erro",
          "Falha ao carregar dados das disciplinas e segmentos"
        );
      });
  };

  loadModulesAndAbilities = async (disciplineId, segmentId) => {
    if (!disciplineId || !segmentId) {
      console.log(
        "loadModulesAndAbilities: disciplineId ou segmentId não disponível",
        {
          disciplineId,
          segmentId
        }
      );
      return;
    }

    if (!this.props.user?.token) {
      console.log("loadModulesAndAbilities: token não disponível");
      return;
    }

    console.log(
      "loadModulesAndAbilities: Carregando módulos e habilidades para disciplina",
      disciplineId,
      "e segmento",
      segmentId
    );

    this.setState({ loadingAbilities: true });

    try {
      const response = await axios.get(
        `${URL.api}classification/ability/moduleAbilityByDiscipline/${disciplineId}/${segmentId}`,
        {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        }
      );

      console.log("loadModulesAndAbilities: Resposta da API", response.data);

      const modulesData = response.data.data?.modules || [];
      const abilitiesData = response.data.data?.abilities || [];
      const modules = modulesData.map(m => ({
        id: m.id,
        name: m.description,
        description: m.description,
        code: m.code,
        type: m.type,
        objective_id: m.objective_id
      }));

      const abilities = abilitiesData.map(a => ({
        id: a.id,
        name: `${a.code} - ${a.description}`,
        code: a.code,
        description: a.description,
        type: a.type,
        objective_id: a.objective_id
      }));

      console.log("loadModulesAndAbilities: Dados processados", {
        modules,
        abilities
      });

      this.setState({
        modules,
        abilities,
        loadingAbilities: false
      });
    } catch (error) {
      console.error("Erro ao carregar módulos e habilidades:", error);
      this.setState({ loadingAbilities: false });
      toastr.error("Erro", "Falha ao carregar módulos e habilidades");
    }
  };

  handleItemDescriptionChange = e => {
    this.setState({ itemDescription: e.target.value });
  };

  createItemFromForm = () => {
    const { itemDescription, ability, useAbility, itemColor } = this.state; // ✅ itemColor está aqui

    const payload = useAbility
      ? {
          description: null,
          abilitie_id: ability || null,
          classification_thematic_unit_id:
            selectedItem?.classification_thematic_unit_id || null,
          color: itemColor || null // ✅ Já está correto
        }
      : {
          description: itemDescription.trim(),
          abilitie_id: ability || null,
          classification_thematic_unit_id: null,
          color: itemColor || null // ✅ Já está correto
        };
    const { selectedItem } = this.state;
    if (!useAbility && !itemDescription.trim()) {
      toastr.error("Erro", "Descrição do item vazia");
      return;
    }

    if (!this.props.user?.token) {
      toastr.error("Erro", "Token não disponível para criar item");
      return;
    }

    const tempItem = useAbility
      ? {
          id: `temp-item-${Date.now()}`,
          description: null,
          abilitie_id: ability || null,
          classification_thematic_unit_id:
            selectedItem?.classification_thematic_unit_id || null,
          color: itemColor || null, // NOVO: incluir cor no item temporário
          _isTemp: true,
          fromAbility: true
        }
      : {
          id: `temp-item-${Date.now()}`,
          description: itemDescription.trim(),
          abilitie_id: ability || null,
          classification_thematic_unit_id: null,
          color: itemColor || null, // NOVO: incluir cor no item temporário
          _isTemp: true
        };

    this.setState({
      selectedItem: tempItem,
      itemDescription: "",
      itemColor: ""
    });
  };

  handleDropdownChange = async (field, value) => {
    const { itemColor, selectedItem } = this.state; // Pega a cor atual e item selecionado

    if (field === "curriculumComponent") {
      this.setState(prevState => ({
        curriculumComponent: value,
        segment: "",
        module: "",
        ability: "",
        modules: [],
        abilities: [],
        selectedItem: prevState.selectedItem?.fromAbility
          ? null
          : prevState.selectedItem
      }));

      const currentSegment = this.state.segment;
      if (value && currentSegment) {
        this.loadModulesAndAbilities(value, currentSegment);
      }
    } else if (field === "segment") {
      this.setState(prevState => ({
        segment: value,
        module: "",
        ability: "",
        modules: [],
        abilities: [],
        selectedItem: prevState.selectedItem?.fromAbility
          ? null
          : prevState.selectedItem
      }));

      const currentCurriculumComponent = this.state.curriculumComponent;
      if (value && currentCurriculumComponent) {
        this.loadModulesAndAbilities(currentCurriculumComponent, value);
      }
    } else if (field === "ability") {
      this.setState({ ability: value });

      if (value) {
        const thematicUnitId = await this.getThematicUnitFromAbility(value);

        this.setState(prevState => {
          const selectedAbility = prevState.abilities.find(
            ab => ab.id === parseInt(value)
          );
          if (selectedAbility) {
            const itemFromAbility = {
              id: `ability-${selectedAbility.id}`,
              description: `${selectedAbility.code} - ${selectedAbility.description}`,
              abilitie_id: selectedAbility.id,
              ability_code: selectedAbility.code,
              ability_description: selectedAbility.description,
              ability: selectedAbility.name,
              classification_thematic_unit_id: thematicUnitId || null,
              color: itemColor || null, // ✅ Usa a cor do state atual
              fromAbility: true
            };

            return { selectedItem: itemFromAbility };
          }
          return {};
        });
      } else {
        this.setState(prevState => ({
          selectedItem: prevState.selectedItem?.fromAbility
            ? null
            : prevState.selectedItem
        }));
      }
    } else {
      this.setState({ [field]: value });
    }
  };

  addAvailableItem = item => {
    const { itemColor } = this.state;
    // Se o item traz habilidade, compor a descrição exibida incluindo código e descrição da habilidade
    const composedItem = { ...item };
    if (item.ability_description || item.ability_code) {
      const codePart = item.ability_code ? `${item.ability_code} - ` : "";
      const abilityText = item.ability_description || item.ability || "";
      composedItem.description = `${codePart}${abilityText}`;
    }

    composedItem.abilitie_id =
      item.abilitie_id ||
      item.ability_id ||
      item.ability ||
      composedItem.abilitie_id ||
      null;

    composedItem.color = itemColor || item.color || null; // NOVO: usar cor selecionada ou a do item
    composedItem._isTemp = true;
    composedItem.fromAvailable = true;
    this.setState({ selectedItem: composedItem, itemColor: "" });
  };

  removeSelectedItem = () => {
    this.setState(prevState => {
      const updates = { selectedItem: null };

      if (prevState.selectedItem?.fromAbility) {
        updates.ability = "";
      }

      return updates;
    });
  };

  handleOpenQuestionToggle = () => {
    this.setState(prevState => ({
      isOpenQuestion: !prevState.isOpenQuestion,
      selectedOptions: prevState.isOpenQuestion ? [] : prevState.selectedOptions
    }));
  };

  handleNewOptionChange = e => {
    this.setState({ newOptionText: e.target.value });
  };

  addNewOption = () => {
    const { newOptionText, selectedOptions, availableOptions } = this.state;
    if (!newOptionText.trim()) return;

    // Verificar se já existe uma opção com o mesmo nome nas opções disponíveis
    const optionExists = availableOptions.find(
      option =>
        option.title.toLowerCase() === newOptionText.trim().toLowerCase()
    );

    if (optionExists) {
      toastr.warning(
        "Aviso",
        "Já existe uma opção disponível com este nome. Use a opção disponível em vez de criar uma nova."
      );
      return;
    }

    if (!this.props.user?.token) {
      toastr.error("Erro", "Token não disponível para criar opção");
      return;
    }

    const payload = { title: newOptionText.trim() };

    const newOption = {
      id: `temp-option-${Date.now()}`,
      title: newOptionText.trim(),
      _isTemp: true
    };
    this.setState({
      selectedOptions: [...selectedOptions, newOption],
      newOptionText: ""
    });
  };

  addAvailableOption = option => {
    const { selectedOptions } = this.state;
    if (!selectedOptions.find(opt => opt.id === option.id)) {
      this.setState({
        selectedOptions: [...selectedOptions, option]
      });
    }
  };

  removeOption = optionId => {
    this.setState(prevState => ({
      selectedOptions: prevState.selectedOptions.filter(
        opt => opt.id !== optionId
      )
    }));
  };

  handleCreate = () => {
    this.setState({ creating: true });

    (async () => {
      try {
        const token = this.props.user?.token;
        if (!token) {
          toastr.error("Erro", "Token não disponível");
          this.setState({ creating: false });
          return;
        }

        let {
          selectedItem,
          selectedOptions,
          isOpenQuestion,
          useAbility,
          itemDescription,
          itemColor
        } = this.state;

        console.log("=== DEBUG CREATE ===");
        console.log("itemColor do state:", itemColor);
        console.log("selectedItem:", selectedItem);

        if (!selectedItem) {
          if (!useAbility && itemDescription && itemDescription.trim()) {
            const payloadItem = {
              description: itemDescription.trim(),
              abilitie_id: null,
              classification_thematic_unit_id: null,
              color: itemColor || null
            };

            console.log("Payload item automático:", payloadItem);

            try {
              const respAutoItem = await axios.post(
                `${URL.api}pedagogical/follow-ups/items/create`,
                payloadItem,
                { headers: { authorization: `Bearer ${token}` } }
              );

              if (!respAutoItem.data?.success) {
                throw new Error("Falha ao persistir item automático");
              }

              selectedItem = respAutoItem.data.data;
              console.log("Item criado (automático):", selectedItem);

              this.setState({ itemDescription: "", itemColor: "" });
            } catch (err) {
              console.error("Erro ao criar item automaticamente:", err);
              toastr.error("Erro", "Falha ao criar item");
              this.setState({ creating: false });
              return;
            }
          } else {
            toastr.error(
              "Erro",
              "Selecione ou crie um item antes de criar a questão"
            );
            this.setState({ creating: false });
            return;
          }
        }

        // Se o item é temporário (não persistido ainda)
        if (selectedItem._isTemp || typeof selectedItem.id === "string") {
          // PRIORIDADE: usar itemColor do state, depois selectedItem.color
          const finalColor = itemColor || selectedItem.color || null;
          const payloadItem = {
            description: selectedItem.abilitie_id
              ? null
              : selectedItem.description || null,
            abilitie_id:
              selectedItem.abilitie_id || selectedItem.ability_id || null,
            classification_thematic_unit_id:
              selectedItem.classification_thematic_unit_id ||
              selectedItem.thematic_unit_id ||
              null,
            color: finalColor // ✅ COR GARANTIDA AQUI
          };

          console.log("Payload item temporário:", payloadItem);
          console.log("Cor sendo enviada:", finalColor);

          const respItem = await axios.post(
            `${URL.api}pedagogical/follow-ups/items/create`,
            payloadItem,
            { headers: { authorization: `Bearer ${token}` } }
          );

          if (!respItem.data?.success)
            throw new Error("Falha ao persistir item");
          selectedItem = respItem.data.data;
          console.log("Item persistido:", selectedItem);
        }

        if (
          !isOpenQuestion &&
          (!selectedOptions || selectedOptions.length === 0)
        ) {
          toastr.error("Erro", "Adicione ao menos uma opção para a questão");
          this.setState({ creating: false });
          return;
        }

        const persistedOptions = [];
        if (isOpenQuestion) {
          const payloadOpt = {
            title: "Resposta livre",
            description: null,
            type: "free-response"
          };
          const respOpt = await axios.post(
            `${URL.api}pedagogical/follow-ups/options/create`,
            payloadOpt,
            {
              headers: { authorization: `Bearer ${token}` }
            }
          );
          if (!respOpt.data?.success)
            throw new Error("Falha ao persistir opção da questão aberta");
          persistedOptions.push(respOpt.data.data);
        } else {
          for (const opt of selectedOptions || []) {
            if (opt._isTemp || typeof opt.id === "string") {
              const payloadOpt = {
                title: opt.title,
                description: opt.description || null,
                type: "multiple-choice"
              };
              const respOpt = await axios.post(
                `${URL.api}pedagogical/follow-ups/options/create`,
                payloadOpt,
                {
                  headers: { authorization: `Bearer ${token}` }
                }
              );
              if (!respOpt.data?.success)
                throw new Error("Falha ao persistir opção");
              persistedOptions.push(respOpt.data.data);
            } else {
              persistedOptions.push(opt);
            }
          }
        }

        const itemsOptionsIds = [];
        for (const opt of persistedOptions) {
          const respLink = await axios.post(
            `${URL.api}pedagogical/follow-ups/items-options/create`,
            {
              item_id: selectedItem.id,
              option_id: opt.id
            },
            {
              headers: { authorization: `Bearer ${token}` }
            }
          );

          if (!respLink.data?.success)
            throw new Error("Falha ao criar vínculo item-opção");
          itemsOptionsIds.push(respLink.data.data.id);
        }

        toastr.success("Questão criada com sucesso!");
        this.props.onClose();
        if (this.props.onQuestionCreated) this.props.onQuestionCreated();
        this.resetModalState();
      } catch (err) {
        console.error("Erro ao criar questão:", err);
        toastr.error("Erro", "Falha ao criar questão");
      } finally {
        this.setState({ creating: false });
      }
    })();
  };

  getThematicUnitFromAbility = async abilityId => {
    if (!abilityId || !this.props.user?.token) return null;

    try {
      const response = await axios.get(
        `${URL.api}classification/ability/singleView/${abilityId}`,
        {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        }
      );

      if (response.data?.success && response.data.data?.ability?.objective_id) {
        const objectiveId = response.data.data.ability.objective_id;
        const objectiveResponse = await axios.get(
          `${URL.api}classification/objective/singleView/${objectiveId}`,
          {
            headers: { authorization: `Bearer ${this.props.user.token}` }
          }
        );

        if (
          objectiveResponse.data?.success &&
          objectiveResponse.data.data?.thematic_unit_id
        ) {
          return objectiveResponse.data.data.thematic_unit_id;
        }
      }
      return null;
    } catch (error) {
      console.error("Erro ao buscar thematic_unit_id da habilidade:", error);
      return null;
    }
  };

  componentDidUpdate(prevProps) {
    if (this.props.isOpen !== prevProps.isOpen) {
      if (this.props.isOpen) {
        document.body.style.overflow = "hidden";
        if (this.state.useAbility) this.loadAbilitiesData();
        this.fetchAvailableItemsOptions();
      } else {
        document.body.style.overflow = "unset";
        this.resetModalState();
      }
    }
  }

  componentWillUnmount() {
    document.body.style.overflow = "unset";
  }

  render() {
    const { isOpen, onClose } = this.props;

    const {
      useAbility,
      itemDescription,
      curriculumComponent,
      segment,
      module,
      ability,
      availableItems,
      selectedItem,
      loadingAbilities,
      isOpenQuestion,
      newOptionText,
      selectedOptions,
      availableOptions,
      creating,
      curriculumComponents,
      segments,
      modules,
      abilities,
      itemColor
    } = this.state;

    // Cores de exemplo para sugestão rápida
    const suggestedColors = [
      "#FF5733",
      "#33FF57",
      "#3357FF",
      "#F333FF",
      "#FFD733",
      "#33FFF5"
    ];

    return (
      <>
        <CModal
          show={isOpen}
          onClose={onClose}
          size="xl"
          backdrop="static"
          className="modal-lg-custom"
        >
          <CModalHeader closeButton>
            <CModalTitle>
              <i className="fa fa-plus mr-2"></i>
              Criar Questão - Acompanhamento Pedagógico
            </CModalTitle>
          </CModalHeader>

          <CModalBody
            style={{
              maxHeight: "70vh",
              overflowY: "auto",
              overflowX: "hidden",
              padding: "20px"
            }}
          >
            <div className="row mb-4">
              <div className="col-md-6">
                <CCard
                  className="mb-3"
                  style={{ minHeight: "620px", height: "auto" }}
                >
                  <CCardHeader>
                    <h6 className="mb-0">
                      <i className="fa fa-edit mr-2"></i>
                      Criação de Item
                    </h6>
                  </CCardHeader>
                  <CCardBody className="card-body-with-dropdowns">
                    <FormGroup className="mb-3">
                      <div className="form-check">
                        <Input
                          type="checkbox"
                          id="abilityCheck"
                          checked={useAbility}
                          onChange={this.handleAbilityToggle}
                          className="form-check-input"
                        />
                        <Label
                          htmlFor="abilityCheck"
                          className="form-check-label"
                        >
                          <strong>Habilidade</strong>
                        </Label>
                      </div>
                    </FormGroup>

                    {/* Seletor de Cor */}
                    <div
                      className="mb-4 p-3"
                      style={{
                        backgroundColor: "#f8f9fa",
                        borderRadius: "8px"
                      }}
                    >
                      <Label>
                        <i className="fa fa-palette mr-2"></i>
                        <strong>Cor do Item (opcional)</strong>
                      </Label>
                      <div className="d-flex align-items-center mt-2">
                        <div
                          className="mr-2"
                          style={{
                            width: "42px",
                            height: "42px",
                            backgroundColor: itemColor || "#ffffff",
                            border: "1px solid #ddd",
                            borderRadius: "4px",
                            cursor: "pointer",
                            boxShadow: itemColor
                              ? `0 0 0 2px ${itemColor}20`
                              : "none"
                          }}
                          onClick={() => {
                            const input = document.createElement("input");
                            input.type = "color";
                            input.value = itemColor || "#000000";
                            input.addEventListener("input", e => {
                              const newColor = e.target.value;
                              this.setState({ itemColor: newColor });
                              // Atualizar item selecionado se existir
                              if (this.state.selectedItem) {
                                this.setState(prevState => ({
                                  selectedItem: {
                                    ...prevState.selectedItem,
                                    color: newColor
                                  }
                                }));
                              }
                            });
                            input.click();
                          }}
                        />
                        <Input
                          type="text"
                          value={itemColor}
                          onChange={e => {
                            this.handleColorChange(e);
                            // Se já tiver um item selecionado, atualizar a cor dele também
                            if (this.state.selectedItem) {
                              this.setState(prevState => ({
                                selectedItem: {
                                  ...prevState.selectedItem,
                                  color: e.target.value
                                }
                              }));
                            }
                          }}
                          placeholder="#RRGGBB (ex: #FF5733)"
                          style={{ flex: 1 }}
                          maxLength={7}
                        />
                        {itemColor && (
                          <CButton
                            color="secondary"
                            size="sm"
                            className="ml-2"
                            onClick={() => {
                              this.setState({ itemColor: "" });
                              // Se já tiver um item selecionado, remover a cor dele também
                              if (this.state.selectedItem) {
                                this.setState(prevState => ({
                                  selectedItem: {
                                    ...prevState.selectedItem,
                                    color: null
                                  }
                                }));
                              }
                            }}
                            title="Remover cor"
                          >
                            <i className="fa fa-times"></i>
                          </CButton>
                        )}
                      </div>
                      <div className="mt-2 d-flex flex-wrap">
                        {suggestedColors.map((color, index) => (
                          <div
                            key={index}
                            onClick={() => {
                              this.setState({ itemColor: color });
                              // Se já tiver um item selecionado, atualizar a cor dele também
                              if (this.state.selectedItem) {
                                this.setState(prevState => ({
                                  selectedItem: {
                                    ...prevState.selectedItem,
                                    color
                                  }
                                }));
                              }
                            }}
                            style={{
                              width: "28px",
                              height: "28px",
                              backgroundColor: color,
                              borderRadius: "4px",
                              marginRight: "6px",
                              marginBottom: "6px",
                              cursor: "pointer",
                              border:
                                itemColor === color
                                  ? "2px solid #333"
                                  : "1px solid #ddd",
                              transform:
                                itemColor === color ? "scale(1.1)" : "scale(1)",
                              transition: "all 0.2s"
                            }}
                            title={color}
                          />
                        ))}
                      </div>
                      <small className="text-muted">
                        <i className="fa fa-info-circle mr-1"></i>
                        Escolha uma cor para identificar visualmente este item
                        nas listas
                      </small>
                    </div>

                    {useAbility ? (
                      <>
                        <FormGroup className="mb-3">
                          <Label>
                            Componente Curricular
                            {loadingAbilities && (
                              <CSpinner size="sm" className="ml-2" />
                            )}
                          </Label>
                          <Input
                            type="select"
                            value={curriculumComponent}
                            disabled={loadingAbilities}
                            onChange={e =>
                              this.handleDropdownChange(
                                "curriculumComponent",
                                e.target.value
                              )
                            }
                          >
                            <option value="">
                              {loadingAbilities
                                ? "Carregando..."
                                : "Selecione..."}
                            </option>
                            {curriculumComponents.map(comp => (
                              <option key={comp.id} value={comp.id}>
                                {comp.name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup className="mb-3">
                          <Label>Segmento</Label>
                          <Input
                            type="select"
                            value={segment}
                            onChange={e =>
                              this.handleDropdownChange(
                                "segment",
                                e.target.value
                              )
                            }
                          >
                            <option value="">Selecione...</option>
                            {segments.map(seg => (
                              <option key={seg.id} value={seg.id}>
                                {seg.name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup className="mb-3">
                          <Label>Módulo</Label>
                          <Input
                            type="select"
                            value={module}
                            onChange={e =>
                              this.handleDropdownChange(
                                "module",
                                e.target.value
                              )
                            }
                          >
                            <option value="">Selecione...</option>
                            {modules.map(mod => (
                              <option key={mod.id} value={mod.id}>
                                {mod.name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>

                        <FormGroup className="mb-3">
                          <Label>Habilidade</Label>
                          <SelectFilter
                            title=""
                            value={ability}
                            options={abilities.map(ab => ({
                              label: ab.name,
                              value: ab.id
                            }))}
                            setFunction={value =>
                              this.handleDropdownChange("ability", value)
                            }
                            disabled={false}
                            placeholder="Selecione..."
                          />
                        </FormGroup>
                      </>
                    ) : (
                      <FormGroup className="mb-3">
                        <Label>Descrição do Item</Label>
                        <Input
                          type="textarea"
                          rows="4"
                          value={itemDescription}
                          onChange={this.handleItemDescriptionChange}
                          placeholder="Digite a descrição do item..."
                        />
                      </FormGroup>
                    )}
                  </CCardBody>
                </CCard>
              </div>

              {useAbility && (
                <div className="col-md-6">
                  <CCard
                    className="mb-3"
                    style={{ minHeight: "620px", height: "auto" }}
                  >
                    <CCardHeader>
                      <h6 className="mb-0">
                        <i className="fa fa-list mr-2"></i>
                        Itens Disponíveis
                      </h6>
                    </CCardHeader>
                    <CCardBody
                      className="card-body-scrollable"
                      style={{
                        height: "auto",
                        maxHeight: "540px",
                        overflowY: "auto"
                      }}
                    >
                      {selectedItem ? (
                        <div className="text-center">
                          <div
                            className="border rounded p-3 mb-1"
                            style={{
                              backgroundColor: selectedItem.color
                                ? `${selectedItem.color}10`
                                : "#f8f9fa",
                              borderLeft: selectedItem.color
                                ? `4px solid ${selectedItem.color}`
                                : "none"
                            }}
                          >
                            <div className="d-flex justify-content-between align-items-center mb-1">
                              <h6 className="text-success mb-0">
                                <i className="fa fa-check-circle mr-2"></i>
                                Item Selecionado
                              </h6>
                              <CButton
                                color="danger"
                                size="sm"
                                onClick={this.removeSelectedItem}
                                title="Remover seleção"
                              >
                                <i className="fa fa-times"></i>
                              </CButton>
                            </div>

                            <div className="text-left">
                              <div>
                                <strong>Descrição:</strong>
                                <div className="mt-2 p-2 border rounded bg-white">
                                  {selectedItem.description}
                                </div>
                              </div>
                              {selectedItem.color && (
                                <div className="mt-2">
                                  <strong>Cor:</strong>
                                  <div className="mt-1 d-flex align-items-center">
                                    <div
                                      style={{
                                        width: "30px",
                                        height: "30px",
                                        backgroundColor: selectedItem.color,
                                        borderRadius: "4px",
                                        marginRight: "8px",
                                        border: "1px solid #ddd"
                                      }}
                                    />
                                    <code>{selectedItem.color}</code>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>

                          <small className="text-muted">
                            Clique no X acima para voltar à lista de items
                            disponíveis
                          </small>
                        </div>
                      ) : (
                        <div className="h-100">
                          {this.state.loadingAvailableItems ? (
                            <div className="loading-center">
                              <CSpinner />
                              <div className="small text-muted mt-2">
                                Carregando itens disponíveis...
                              </div>
                            </div>
                          ) : this.state.availableItems.length === 0 ? (
                            <div className="text-center py-4 text-muted">
                              Nenhum item disponível.
                            </div>
                          ) : (
                            this.state.availableItems.map(item => (
                              <div
                                key={item.id}
                                className="border rounded p-2 mb-2 bg-white"
                                style={{
                                  borderLeft: item.color
                                    ? `4px solid ${item.color}`
                                    : "none"
                                }}
                              >
                                <div className="d-flex justify-content-between align-items-center">
                                  <div className="flex-grow-1">
                                    <div className="d-block small text-muted">
                                      {item.ability_code
                                        ? `${item.ability_code} - ${
                                            item.ability_description ||
                                            item.ability ||
                                            ""
                                          }`
                                        : item.ability_description ||
                                          item.ability ||
                                          ""}
                                    </div>
                                    <div className="d-block small text-muted">
                                      {item.description}
                                    </div>
                                    {item.color && (
                                      <div className="mt-1">
                                        <span
                                          className="badge"
                                          style={{
                                            backgroundColor: item.color,
                                            color: "#fff",
                                            fontSize: "10px"
                                          }}
                                        >
                                          {item.color}
                                        </span>
                                      </div>
                                    )}
                                  </div>
                                  <div className="d-flex align-items-center ml-3">
                                    <CButton
                                      color="primary"
                                      size="sm"
                                      onClick={() =>
                                        this.addAvailableItem(item)
                                      }
                                    >
                                      Adicionar
                                    </CButton>
                                  </div>
                                </div>
                              </div>
                            ))
                          )}
                        </div>
                      )}
                    </CCardBody>
                  </CCard>
                </div>
              )}
            </div>

            <div className="row">
              <div className="col-md-6">
                <CCard style={{ height: "350px" }}>
                  <CCardHeader>
                    <h6 className="mb-0">
                      <i className="fa fa-list mr-2"></i>
                      Criação de Opções
                    </h6>
                  </CCardHeader>
                  <CCardBody className="card-body-scrollable">
                    <FormGroup className="mb-3">
                      <div className="form-check">
                        <Input
                          type="checkbox"
                          id="openQuestionCheck"
                          checked={isOpenQuestion}
                          onChange={this.handleOpenQuestionToggle}
                          className="form-check-input"
                        />
                        <Label
                          htmlFor="openQuestionCheck"
                          className="form-check-label"
                        >
                          <strong>Questão Aberta</strong>
                        </Label>
                      </div>
                    </FormGroup>

                    {isOpenQuestion ? (
                      <div className="text-center text-muted py-4">
                        <i className="fa fa-pencil-square-o fa-3x mb-3 text-primary"></i>
                        <p>Questão configurada como resposta aberta.</p>
                        <small>
                          Os professores poderão escrever suas respostas
                          livremente.
                        </small>
                      </div>
                    ) : (
                      <>
                        <FormGroup className="mb-3">
                          <Label>Nova Opção</Label>
                          <InputGroup>
                            <Input
                              type="text"
                              value={newOptionText}
                              onChange={this.handleNewOptionChange}
                              placeholder="Digite a nova opção..."
                              onKeyPress={e =>
                                e.key === "Enter" && this.addNewOption()
                              }
                            />
                            <InputGroupAddon addonType="append">
                              <CButton
                                color="primary"
                                onClick={this.addNewOption}
                                disabled={!newOptionText.trim()}
                              >
                                <i className="fa fa-plus"></i>
                              </CButton>
                            </InputGroupAddon>
                          </InputGroup>
                        </FormGroup>

                        {selectedOptions.length > 0 && (
                          <div className="mb-3">
                            <Label>Opções Adicionadas</Label>
                            <div
                              style={{ maxHeight: "150px", overflowY: "auto" }}
                            >
                              {selectedOptions.map((option, index) => (
                                <div
                                  key={option.id}
                                  className="d-flex justify-content-between align-items-center border rounded p-2 mb-2 bg-light"
                                >
                                  <span>{option.title}</span>
                                  <CButton
                                    color="danger"
                                    size="sm"
                                    onClick={() => this.removeOption(option.id)}
                                  >
                                    <i className="fa fa-times"></i>
                                  </CButton>
                                </div>
                              ))}
                            </div>
                          </div>
                        )}
                      </>
                    )}
                  </CCardBody>
                </CCard>
              </div>

              <div className="col-md-6">
                {!isOpenQuestion && (
                  <CCard style={{ height: "350px" }}>
                    <CCardHeader>
                      <h6 className="mb-0">
                        <i className="fa fa-check-square mr-2"></i>
                        Opções Disponíveis
                      </h6>
                    </CCardHeader>
                    <CCardBody
                      className="card-body-scrollable"
                      style={{ height: "calc(100% - 60px)" }}
                    >
                      <div className="h-100">
                        {this.state.loadingAvailableOptions ? (
                          <div className="loading-center">
                            <CSpinner />
                            <div className="small text-muted mt-2">
                              Carregando opções disponíveis...
                            </div>
                          </div>
                        ) : this.state.availableOptions.filter(
                            option =>
                              !selectedOptions.find(sel => sel.id === option.id)
                          ).length === 0 ? (
                          <div className="text-center py-4 text-muted">
                            Nenhuma opção disponível.
                          </div>
                        ) : (
                          this.state.availableOptions
                            .filter(
                              option =>
                                !selectedOptions.find(
                                  sel => sel.id === option.id
                                )
                            )
                            .map(option => (
                              <div
                                key={option.id}
                                className="border rounded p-2 mb-2 bg-white"
                              >
                                <div className="d-flex justify-content-between align-items-center">
                                  <span className="d-block small text-muted">
                                    {option.title}
                                  </span>
                                  <div className="d-flex align-items-center ml-3">
                                    <CButton
                                      color="primary"
                                      size="sm"
                                      onClick={() =>
                                        this.addAvailableOption(option)
                                      }
                                    >
                                      Adicionar
                                    </CButton>
                                  </div>
                                </div>
                              </div>
                            ))
                        )}
                      </div>
                    </CCardBody>
                  </CCard>
                )}
              </div>
            </div>
          </CModalBody>

          <CModalFooter>
            <CButton color="secondary" onClick={onClose} disabled={creating}>
              Cancelar
            </CButton>
            <CButton
              color="success"
              onClick={this.handleCreate}
              disabled={creating}
              className="d-flex justify-content-center align-items-center"
            >
              {creating ? (
                <>
                  <CSpinner size="sm" className="mr-2" />
                  Criando...
                </>
              ) : (
                <>
                  <i className="fa fa-check mr-2"></i>
                  Criar
                </>
              )}
            </CButton>
          </CModalFooter>
        </CModal>
      </>
    );
  }
}

export default QuestionModal;
